import { render, staticRenderFns } from "./ObjetivoEspecifico.vue?vue&type=template&id=3e565966&scoped=true"
import script from "./ObjetivoEspecifico.vue?vue&type=script&lang=js"
export * from "./ObjetivoEspecifico.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoEspecifico.vue?vue&type=style&index=0&id=3e565966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e565966",
  null
  
)

export default component.exports